export default __webpack_public_path__ + "static/media/calendar.b2fd6d66.png";